import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-workshop-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './workshop-faq.component.html',
  styleUrls: ['./workshop-faq.component.scss']
})
export class WorkshopFaqComponent {
  activeIndex: number | null = null; 

  faqList: FaqItem[] = [
    {
      question: 'How long is the workshop?',
      answer: 'The workshop is a single on-campus session covering an introduction to AIKosh, guided dataset and model exploration, hands-on activities, and a briefing on the post-workshop challenge. Duration varies by cohort size and academic profile.'
    },
    {
      question: 'Do students need coding knowledge?',
      answer: 'Some familiarity with basic programming concepts is helpful for the technical track, but not mandatory. The programme is designed to educate and upskill participants across all levels, with domain-focused cohorts guided through problem framing, dataset interpretation, and sectoral applications instead.'
    },
    {
      question: 'Which department can participate?',
      answer: 'The programme is open to students from all departments and streams. Whether you are from engineering, medicine, law, economics, social sciences, or the arts, if you are curious about AI and want to explore India\'s national AI platform, you are welcome to join.'
    },
    {
      question: 'Is there any cost for this programme?',
      answer: 'The programme is free for students. IndiaAI provides the workshop content, materials, and standardised resources, with the university responsible for venue, devices, and student mobilisation at no cost to students.'
    },
  //  {
    //  question: 'What is the AIKosh Ambassador Programme?',
      //answer: 'Students who demonstrate strong engagement across the programme may be considered as AIKosh Ambassadors, recognising them as platform advocates and connecting them to future IndiaAI initiatives, challenges, and opportunities.'
    //},
    {
      question: 'How can universities register?',
      answer: 'Universities apply through a Call for Proposals process. Post evaluation, selected universities are onboarded and provided with all standardised materials to run the programme independently.'
    },
    {
      question: 'Are certificates provided?',
      answer: 'Yes. All students who attend the workshop and complete the guided platform activity receive a digitally issued certificate from IndiaAI recognising their participation.'
    },
    {
      question: 'Are there any prizes or incentives?',
      answer: 'Yes. Strong submissions in the post-workshop challenge, as evaluated by the university, may receive financial incentives from IndiaAI, subject to fund availability. Faculty evaluators also receive a formal letter of recognition and an honorarium upon completion.'
    }
  ];

  // Accordion toggle handler
  toggleFaq(index: number): void {
    if (this.activeIndex === index) {
      this.activeIndex = null; 
    } else {
      this.activeIndex = index; // Open the clicked item
    }
  }
}
